var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('classic-container',{attrs:{"title":_vm.$t('site-administration.no-site.title')}},[_c('p',[_vm._v(_vm._s(_vm.$t('site-administration.no-site.content')))])])}
var staticRenderFns = []

export { render, staticRenderFns }